import { dequal } from 'dequal'
import { ROUTES } from '@constants/index'
import { HostEnvironment, HostSession } from '@typesApp/Environment'
import { ActionModule } from '@typesApp/ActionModule'
import { normalizeBrand } from './normalizeBrand'

type SessionParameters = {
  isLoggingOut: boolean
  isSessionExpired: boolean
  session?: HostSession
}

type CanRequestTokenParameters = {
  session: HostSession
  actionModule?: ActionModule
}

const isGuest = (session?: HostSession): boolean => {
  return session?.isGuest === true
}

export const isAnonymousSession = (session?: HostSession): boolean => {
  return !isGuest(session) && !session?.sessionId && !session?.cartId
}

export const sessionValid = (args: SessionParameters): boolean => {
  const { isLoggingOut, isSessionExpired, session } = args
  if (isSessionExpired) return false

  return (
    (!isLoggingOut || Boolean(session?.isLoggedIn) || isGuest(session) || Boolean(session?.isPartiallyAuthenticated)) &&
    Boolean(session?.sessionId)
  )
}

export const isGuestSessionWithUserId = (session?: HostSession): boolean => {
  return isGuest(session) && Boolean(session?.userId)
}

export const isSessionChanged = (source?: HostSession, target?: HostSession): boolean => {
  return (
    source?.isLoggedIn !== target?.isLoggedIn ||
    source?.isPartiallyAuthenticated !== target?.isPartiallyAuthenticated ||
    source?.cartId !== target?.cartId ||
    source?.sessionId !== target?.sessionId ||
    source?.userId !== target?.userId
  )
}

export const canRequestAuthToken = (params: CanRequestTokenParameters): boolean => {
  const { session } = params
  return session?.isPartiallyAuthenticated || session?.isLoggedIn || isGuest(session)
}

export const normalizeEnvironment = (environment?: HostEnvironment): HostEnvironment | null => {
  return environment
    ? {
        ...environment,
        brand: normalizeBrand(environment.brand),
        basePath: getBasePath(),
        basePathSearch: window.location.search ?? '',
      }
    : null
}

const getBasePath = (): string => {
  const routeBase = ROUTES.BASE.replace('/', '')

  // eslint-disable-next-line no-restricted-globals
  let basePath = window.location.pathname
  const pathArray = basePath.split('/')
  if (pathArray.includes(routeBase)) {
    const dbIndex = pathArray.indexOf(routeBase)
    basePath = pathArray.slice(0, dbIndex).join('/')
  }
  return basePath
}

export const isEnvironmentChanged = (source?: HostEnvironment, target?: HostEnvironment): boolean => {
  return !dequal(source, target)
}

export const initGlobalLocale = (environment: HostEnvironment) => {
  if (window.directBilling?.env) {
    window.directBilling.env.locale = environment.locale
    window.directBilling.env.currency = environment.currency
  }
}
